<template>
    <div class="app__tab second_step" :class="{ disable: availableStep < 2 }">
        <div class="app__tab_title" @click="goToStep(2)">
            <span>2</span>
            <p>Выбор по двс, мощности, топливу</p>
        </div>
        <transition name="fade">
            <div v-show="step === 2" class="app__tab-wrapper">
                <div class="sub-wrapper">
                    <div class="date-buttons">
                        <template v-for="(item, key) in engineList">
                            <el-button
                                v-if="item.length"
                                :key="`year_${key}`"
                                :class="{ active: key === selectedYear }"
                                @click.prevent="selectedYear = key"
                            >
                                {{ key }}
                            </el-button>
                        </template>
                    </div>
                    <div class="date-buttons fuel-buttons">
                        <template v-for="item in typeFuel">
                            <el-button
                                v-if="item.length"
                                :key="`fuel_${item}`"
                                :class="{ active: item === selectedTypeFuel }"
                                @click.prevent="selectedTypeFuel = item"
                            >
                                {{ item }}
                            </el-button>
                        </template>
                    </div>
                    <el-table
                        ref="enginesTable"
                        :data="dvsTableData"
                        style="width: 100%"
                        highlight-current-row
                        @current-change="setCurrentEngine"
                        @row-dblclick="goToStep(3), handleCurrentChange()"
                    >
                        <el-table-column label="dvs" prop="dvs">
                            <template slot="header" slot-scope="scope">
                                Двигатель
                                
                            </template>
                        </el-table-column>
                        <el-table-column label="engPower" prop="engPower">
                            <template slot="header" slot-scope="scope">
                                Мощность
                                
                            </template>
                        </el-table-column>
                        <el-table-column label="fuel_info" prop="fuel_info">
                            <template slot="header" slot-scope="scope">
                                Топливо
                               
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="app__buttons">
                    <button class="btn" @click="goToStep(1)">Назад</button>
                    <button
                        class="btn"
                        :class="{ disable: !currentEngine }"
                        @click="goToStep(3), handleCurrentChange()"
                    >
                        Применить
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "EngineSelection",
    props: {
        API_URL: { type: String },
        step: { type: Number },
        availableStep: { type: Number },
    },
    data: () => ({
        modelId: null,
        engineId: null,
        engineList: {},
        selectedYear: "Все",
        currentEngine: {},
        selectedTypeFuel: 'Бензин',
        typeFuel: ["Бензин", "Дизель"]
    }),
    mounted() {
        if (this.selectedModel) {
            this.getEnginesFromApi();
        }
    },
    methods: {
        goToStep(step) {
            this.$emit("goToStep", step);
        },

        currStep() {
            let index = this.dvsTableData.findIndex((x) => {
                return x.id === this.selectedEngineId;
            });
            this.$refs.enginesTable.setCurrentRow(this.dvsTableData[index]);
        },
        /**
         * Отправка запроса для получения информации по двигателю
         */
        getEnginesFromApi() {
            return new Promise((resolve, reject) => {
                fetch(
                    `${this.API_URL}engineList?vehicleModelId=${this.selectedModelId}`,
                    {
                        headers: {
                            Authorization:
                                "Bearer e09421f76fc24dbbbfdcf0adb9a87c5a",
                        },
                    }
                )
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        this.engineList = response;

                        // restore default values
                        this.selectedYear = 'Все';
                        this.selectedTypeFuel = window.innerWidth < 768 ? this.typeFuel[0] : null;
                        this.currStep();
                    })
                    .then(() => {
                        resolve();
                    });
            });
        },
        setCurrentEngine(node) {
            this.currentEngine = node;
            if (this.currentEngine) {
                this.$store.dispatch("updateStateValue", {
                    target: "maxAvailableStep",
                    value:
                        this.selectedEngineId === this.currentEngine.id ? 3 : 2,
                });
            }
        },
        /**
         * Отслеживание получения данных из строки в таблице
         */
        handleCurrentChange() {
            let oldId = this.selectedEngineId;
                
            this.$store
                .dispatch("updateStateValue", {
                    target: "engine",
                    value: this.currentEngine,
                })
                .then(() => {
                    if (
                        !this.selectedEngine ||
                        this.selectedEngine.id !== oldId
                    ) {
                        this.$emit("getWorksFromApi");
                    }
                });
        },
        /**
         * Сброс параметров по двигателю
         */
        resetEngines() {
            this.engineId = null;
            this.$store
                .dispatch("updateStateValue", {
                    target: "engine",
                    value: null,
                })
                .then(() => {
                    this.engineList = [];
                });
        },
    },
    computed: {
        /**
         * Отслеживание модели
         */
        selectedModel() {
            if(!this.$store.getters["getValue"]("model")){
                this.engineList = []
            }
            return this.$store.getters["getValue"]("model");
        },
        /**
         * Отслеживание ID модели
         */
        selectedModelId() {
            return (this.modelId = this.selectedModel
                ? this.selectedModel.id
                : null);
        },
        /**
         * Отслеживание двигателя
         */
        selectedEngine() {
            return this.$store.getters["getValue"]("engine");
        },

        /**
         * Отслеживание ID двигателя
         */
        selectedEngineId() {
            return (this.engineId = this.selectedEngine
                ? this.selectedEngine.id
                : null);
        },
        selectedWorks() {
            return this.$store.getters["getValue"]("apiWorks");
        },
        /**
         * Фильтрация таблицы по году
         */
        selectedDvsByYear() {
            if (Object.keys(this.engineList).length === 0) {
                return [];
            }

            return this.selectedTypeFuel ? this.engineList[this.selectedYear].filter(data => data.fuel_info === this.selectedTypeFuel) : this.engineList[this.selectedYear];
        },
        /**
         * Фильтрация таблицы по поиску
         */
        dvsTableData() {
            if (!this.selectedDvsByYear) return [];
            return this.selectedDvsByYear;
        },
    },
};
</script>